import PropTypes from "prop-types";
import { Box, Chip, Typography } from "@mui/material";
import { switchDate } from "../../../model/switchModel";
export default function StatisticsPanel({ stats, lastUpdated }) {
  return (
    <Box sx={{ my: 2, p: 2, border: "1px solid #dce5ed", borderRadius: 2, bgcolor: "#fff" }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "repeat(2,1fr)", md: "repeat(4,1fr)" },
          gap: 1.5,
          mb: 2,
        }}
      >
        {[
          ["Switches filtrados", stats.totalGroups, "#245a83", "#edf4ff"],
          ["Puertos registrados", stats.totalPorts, "#116979", "#e8f7f9"],
          ["Automático habilitado", stats.activePorts, "#217346", "#edf8f0"],
          ["Automático deshabilitado", stats.inactivePorts, "#526579", "#eef3f8"],
        ].map(([label, value, color, background]) => (
          <Box
            key={label}
            sx={{ p: 1.5, bgcolor: background, borderRadius: 2, borderTop: `3px solid ${color}` }}
          >
            <Typography sx={{ color, fontSize: ".75rem", fontWeight: 600 }}>{label}</Typography>
            <Typography sx={{ color, fontSize: "1.6rem", fontWeight: 700 }}>
              {value.toLocaleString("es-CO")}
            </Typography>
          </Box>
        ))}
      </Box>
      <Typography sx={{ fontSize: ".8rem", color: "#243b53", fontWeight: 600, mb: 1 }}>
        Resultados registrados por puerto
      </Typography>
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
        {[
          ["Exitosos", stats.success, "#217346", "#e4f3e9"],
          ["Sin alcance", stats.error, "#b42318", "#fde5e2"],
          ["Advertencias", stats.warning, "#885515", "#fff1d5"],
          ["Informativos", stats.info, "#245a83", "#e8eff7"],
          ["Sin clasificar / Sin registro", stats.unknown, "#526579", "#eef3f8"],
        ].map(([label, value, color, bgcolor]) => (
          <Chip
            key={label}
            size="small"
            label={`${label}: ${value}`}
            sx={{ color, bgcolor, fontWeight: 600 }}
          />
        ))}
      </Box>
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 1.5 }}>
        <Typography sx={{ fontSize: ".75rem", color: "#526579" }}>
          Último intento registrado: {switchDate(stats.lastReset)}
        </Typography>
        <Typography sx={{ fontSize: ".75rem", color: "#526579" }}>
          Última consulta correcta: {switchDate(lastUpdated)}
        </Typography>
      </Box>
      <Typography sx={{ fontSize: ".72rem", color: "#526579", mt: 0.75 }}>
        Totales según los switches filtrados. Las respuestas guardadas no representan una
        comprobación de conectividad actual.
      </Typography>
    </Box>
  );
}
StatisticsPanel.propTypes = { stats: PropTypes.object.isRequired, lastUpdated: PropTypes.string };
